import { MessageRetailerOrBrandButton, SELF_SERVE_GENERAL_DESCRIPTION_WITH_CONTEXT, SELF_SERVE_GENERAL_TITLE_WITH_CONTEXT, additionalDataRequiredForContactingRetailerOrBrandCTA } from "../../shared/instantAnswerUtils";
export var GeneralContactRetailerIA = function GeneralContactRetailerIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return SELF_SERVE_GENERAL_TITLE_WITH_CONTEXT(strictLocalize, context);
    },
    descriptionBuilder: function descriptionBuilder(context) {
      var description = SELF_SERVE_GENERAL_DESCRIPTION_WITH_CONTEXT(strictLocalize, context);
      if (!description) {
        return [];
      }
      return [description];
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _MessageRetailerOrBra;
        return (_MessageRetailerOrBra = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra === void 0 ? void 0 : _MessageRetailerOrBra.label;
      },
      onClickFunctionBuilder: function onClickFunctionBuilder(context) {
        var _MessageRetailerOrBra2;
        return (_MessageRetailerOrBra2 = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra2 === void 0 ? void 0 : _MessageRetailerOrBra2.onClick;
      }
    },
    additionalRequiredData: additionalDataRequiredForContactingRetailerOrBrandCTA()
  };
};